import React from "react";
import Index from "./Pages/Admin/index";

const Routs = () =>{
    return(<Index/>)
}

export default Routs;